import {
  GET_SURVEYCONCEPT_FAIL,
  GET_SURVEYCONCEPT_SUCCESS,
  GET_SURVEYCONCEPTS_FAIL,
  GET_SURVEYCONCEPTS_SUCCESS,
  ADD_SURVEYCONCEPT_SUCCESS,
  ADD_SURVEYCONCEPT_FAIL,
  UPDATE_SURVEYCONCEPT_SUCCESS,
  UPDATE_SURVEYCONCEPT_FAIL,
  DELETE_SURVEYCONCEPT_SUCCESS,
  DELETE_SURVEYCONCEPT_FAIL,  
  SET_STATE_SURVEYCONCEPT
} from "./actionTypes";

const INIT_STATE = {
  surveyConcepts: [],
  surveyConcept: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const surveyConcepts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SURVEYCONCEPTS_SUCCESS:
      return {
        ...state,
        surveyConcepts: action.payload.surveyConcepts,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_SURVEYCONCEPT:
      return { ...state, loading: action.payload }

    case GET_SURVEYCONCEPTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_SURVEYCONCEPT_SUCCESS:
      return {
        ...state,
        surveyConcepts: [...state.surveyConcepts, action.payload],
      };

    case ADD_SURVEYCONCEPT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_SURVEYCONCEPT_SUCCESS:
      return {
        ...state,
        surveyConcepts: state.surveyConcepts.map(surveyConcept =>
          surveyConcept.id.toString() === action.payload.id.toString()
            ? { ...action.payload, surveyConcept }
            : surveyConcept
        ),
      };

    case UPDATE_SURVEYCONCEPT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_SURVEYCONCEPT_SUCCESS:
      return {
        ...state,
        surveyConcepts: state.surveyConcepts.filter(
          surveyConcept => surveyConcept.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_SURVEYCONCEPT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_SURVEYCONCEPT_SUCCESS:
      return {
        ...state,
        surveyConcept: action.payload,
      };

    case GET_SURVEYCONCEPT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default surveyConcepts;
